import { FC } from 'react';
import { DefaultCell } from '@silverfort/sf-components';

type Props = {
    domain: string;
};

const DomainCell: FC<Props> = ({ domain }) => {
    return <DefaultCell text={domain} />;
};

export default DomainCell;
